import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Cookies from "js-cookie";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import AnimatedRoutes from "./AnimatedRoutes";
import { hidePageLoader, showPageLoader, waitForCurrentPageAssets } from "./pageLoadStatus";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const storedLang = Cookies.get("i18next");
  const [currentLang, setCurrentLang] = useState(storedLang || "en");

  useEffect(() => {
    const loader = document.getElementById("loader");

    if (loader) {
      showPageLoader();
    }

    waitForCurrentPageAssets().finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    if (!isLoading) {
      hidePageLoader();
    }
  }, [isLoading]);

  useEffect(() => {
    if (!isLoading) {
      let isCancelled = false;

      waitForCurrentPageAssets().then(() => {
        if (!isCancelled) {
          hidePageLoader();
        }
      });

      return () => {
        isCancelled = true;
      };
    }
  }, [currentLang, isLoading]);

  return (
    <Router>
      <Header currentLang={currentLang} storedLang={storedLang} setCurrentLang={setCurrentLang} />
      <AnimatedRoutes currentLang={currentLang} />
      <Footer />
    </Router>
  );
}

export default App;
